import { REPUBS } from '~/vendor/cx-modules/constants';
import { type Repub } from '~/vendor/cx-modules/types';

const bookmakerCount: Partial<Record<Repub, number>> = {
  [REPUBS.GZ.name]: 2,
};

export const hasMinBookmakersForRepub = (repubName: Repub, bookmakersCount?: number) => {
  const minBookmakers = bookmakerCount[repubName] ?? 1;
  return (bookmakersCount || 1) >= minBookmakers;
};
